/**
 * Country and State Selector Component
 *
 */

// deps
import PropTypes from 'prop-types';

// internals
const internals = {};

internals.lookUpCountryId = (countryCode, countryArray = []) => {
  if (!countryArray.length) {
    return 0;
  }

  const country = countryArray.find((el) => el.code === countryCode);

  return country.id;
};

const {Component, Fragment} = React;

export default class CountryStateSelector extends Component {
  static propTypes = {
    updateExternalState: PropTypes.func.isRequired,
    countryName: PropTypes.string.isRequired,
    stateName: PropTypes.string.isRequired,
    countries: PropTypes.array.isRequired,
    states: PropTypes.array.isRequired,
    wrapperClassName: PropTypes.string,
    isStateInput: PropTypes.bool,
    isStateRequired: PropTypes.bool,
    countryLabelWrapper: PropTypes.string,
    countryLabel: PropTypes.string,
    countryInputWrapper: PropTypes.string,
    stateLabelWrapper: PropTypes.string,
    stateLabel: PropTypes.string,
    stateInputWrapper: PropTypes.string,
    hideStates: PropTypes.bool,
    showStateInput: PropTypes.bool,
    countryId: PropTypes.string,
  };

  static defaultProps = {
    wrapperClassName: '',
    updateExternalState: () => {},
    isStateInput: false,
    countryLabel: 'Country',
    countryLabelWrapper: 'sm-3',
    countryInputWrapper: 'sm-9',
    stateLabel: 'State',
    stateLabelWrapper: 'sm-3',
    stateInputWrapper: 'sm-9',
    isStateRequired: true,
    hideStates: false,
    showStateInput: true,
    countryId: 'gcvCountryFieldId'
  };

  constructor() {
    super();

    this.state = {
      selectedCountry: '',
      selectedCountryId: '',
      selectedState: ''
    };
  }

  _onChangeCountrySelector = (event) => {
    if (event.target.name === this.props.countryName) {

      const countryId = internals.lookUpCountryId(event.target.value, this.props.countries);

      this.setState({
        selectedCountry: event.target.value,
        selectedCountryId: countryId,
        selectedState: ''
      });
    } else if (event.target.name === this.props.stateName) {

      this.setState({
        selectedState: event.target.value
      });
    }

    return 0;
  }

  _filterStates = (countryId, statesArray) => {

    if (countryId) {
      return statesArray.filter((el) => el.countryId === countryId || el.countryId === '');
    }

    return [];
  }

  _renderStateSelector = () => {

    const statesOptionArray = this._filterStates(this.state.selectedCountryId, this.props.states).map((el, index) => (<option key={`${el.code}-${index}`} value={el.code}>{el.name}</option>));

    return (
      <Fragment>
        {!this.props.hideStates ? 
          <label htmlFor={`${this.props.stateName}`} className={`form-label xs-12 ${this.props.stateLabelWrapper}`}>
          {this.props.stateLabel} <span>*</span>
        </label>
        : ''}
        
        {!this.props.hideStates ?
        <div className={`xs-12 control-wrapper custom-ddl ${this.props.stateInputWrapper}`}>
          <select
            className="gcvStateField"
            name={`${this.props.stateName}`}
            onChange={ this._onChangeCountrySelector }
            disabled={ !this.state.selectedCountry.length > 0 }
            required={this.props.isStateRequired}
          >
            <option value="">Select a Country First</option>
            { statesOptionArray }
          </select>
        </div>
        : ''
        }
        
      </Fragment>
    );
  }

  _renderStateInput = () => {
    return (
      <Fragment>
        <label htmlFor={`${this.props.stateName}`} className={`form-label xs-12 ${this.props.stateLabelWrapper}`}>
          {this.props.stateLabel} <span>*</span>
        </label>
        <div className={`xs-12 control-wrapper ${this.props.stateInputWrapper}`}>
          <input
            type="text"
            className="gcvStateFieldOther"
            onChange={ this._onChangeCountrySelector }
            name={`${this.props.stateName}`}
            id={`${this.props.stateName}`}
            required={this.props.isStateRequired}
          />
        </div>
      </Fragment>
    );
  }

  _renderCountryOption = (countryArray = []) => {

    const usaInformation = countryArray[countryArray.findIndex((el) => el.code === 'US')] || {};
    const canadaInformation = countryArray[countryArray.findIndex((el) => el.code === 'CA')] || {};
    const ukInformation = countryArray[countryArray.findIndex((el) => el.code === 'GB')] || {};
    const defaultOption = countryArray[0];
    const filteredCountryArray = countryArray.filter((el) => el.code !== '' && el.code !== 'US' && el.code !== 'CA' && el.code !== 'GB');

    return [defaultOption, usaInformation, canadaInformation, ukInformation, ...filteredCountryArray];
  }

  render() {
    const isStateInput = (this.state.selectedCountry === 'US' || this.state.selectedCountry === 'GB' || this.state.selectedCountry === 'CA') ? false : true;

    return (
      <div className={`${this.props.wrapperClassName}`}>
        <div className="row">
          <label htmlFor={`${this.props.countryName}`} className={`form-label single-line xs-12 ${this.props.countryLabelWrapper}`}>
            {this.props.countryLabel} <span>*</span>
          </label>
          <div className={`xs-12 control-wrapper custom-ddl ${this.props.countryInputWrapper}`}>
            <select
              name={`${this.props.countryName}`}
              className="gcvCountryField"
              id={`${this.props.countryId}`}
              onChange={ this._onChangeCountrySelector }
              required
            >
              {
                this.props.countries.length > 1 ? this._renderCountryOption(this.props.countries).filter((el) => el.name).map((el) => (<option key={el.id} value={el.code}>{el.name}</option>)) : <option value="">Select a Country</option>
              }
            </select>
          </div>
          {
            (!isStateInput || this.state.selectedCountry === '') && this._renderStateSelector()
          }
          {
            (isStateInput && this.props.showStateInput && this.state.selectedCountry.length > 0) && this._renderStateInput()
          }
        </div>
      </div>
    );
  }
}
